import userApi from '@/modules/projectA/api/user';

export default {
  data() {
    return {
      // true表示隐藏 false表示显示
      isHiddenAgreement: false,
    };
  },
  methods: {
    // 包含就是true, 不需要弹窗
    async hideCompaniesFn() {
      const res = await userApi.isHiddenInquiryAndComparisonAgreement({});
      if (res.code === '200') {
        this.isHiddenAgreement = res.data;
      }
    },
    async hideCompaniesByIdFn(companyId) {
      const res = await userApi.isHiddenInquiryAndComparisonAgreementByCompanyId({ companyId });
      if (res.code === '200') {
        return res.data;
      }
      return false;
    },
  },
  async mounted() {
    const { purchaseCompanyId } = this.$route.query;
    if (purchaseCompanyId) {
      this.isHiddenAgreement = await this.hideCompaniesByIdFn(purchaseCompanyId);
    } else {
      this.hideCompaniesFn();
    }
  },
};
